import * as React from "react";
import type { SVGProps } from "react";
const ArrowDownBigIcon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path fill="currentColor" fillRule="evenodd" d="M17.507 13.003a.75.75 0 0 0-1.06.045l-3.697 4.027V5a.75.75 0 0 0-1.5 0v12.075l-3.698-4.027a.75.75 0 1 0-1.104 1.015l5 5.444a.75.75 0 0 0 1.104 0l5-5.444a.75.75 0 0 0-.045-1.06" clipRule="evenodd" /></svg>;
export default ArrowDownBigIcon;